import React from 'react';
import { LabelIcon } from './LabelIcons';
import './labels.css';

const LabelSelector = ({
  labels = [],
  selectedIds = [],
  onToggle,
  onCreate,
  emptyText = 'No labels yet',
}) => (
  <div className="label-selector" role="menu" aria-label="Labels">
    <div className="label-selector-title">Labels</div>
    {!labels.length && <div className="label-selector-empty">{emptyText}</div>}
    {labels.map((label) => {
      const active = selectedIds.includes(String(label._id));
      return (
        <button
          key={label._id}
          type="button"
          className={`label-selector-item${active ? ' is-active' : ''}`}
          role="menuitemcheckbox"
          aria-checked={active}
          onClick={() => onToggle?.(label, !active)}
        >
          <span className="label-chip-dot" style={{ '--label-color': label.color || '#1a73e8', background: label.color || '#1a73e8' }} />
          <LabelIcon name={label.icon || 'label'} size={16} color={label.color || '#1a73e8'} />
          <span>{label.name}</span>
          {active && <span className="label-selector-check">✓</span>}
        </button>
      );
    })}
    {onCreate && (
      <button type="button" className="label-selector-item" onClick={onCreate}>
        <span>+</span>
        <span>Create new label</span>
      </button>
    )}
  </div>
);

export default LabelSelector;
